import Shipments from "../../../containers/shipments/shipments";
import { getApiUrl } from "../../../utils/baseUrl";
import { filterTypeDictionary as filterType, analyticsTypeDictionary as analyticsType, autoSuggestLanguageDictionary as autosuggestLanguageOptions, redirectingProfileEnum, categoryType } from "../../../core/global/global-country-dictionary";
import { globalCountryDetailsDictionary as globalCountryDetails } from "../../../core/global/global-country-details";

export const analyticDropdownOptions = [
  { value: "shipments", label: "Number of Shipments", two_table_header: "Total Shipments" },
  { value: "value", label: "Shipment Value (USD)", two_table_header: "Total Value (USD)" },
  { value: "weight", label: "Weight (kg)", two_table_header: "Total Weight (kg)" },
];
export const trendsDropdownOptions = [
  { value: "shipments", label: "Shipments", table_header: "Total Shipments" },
  { value: "value", label: "Value (USD)", table_header: "Total Value (USD)" },
  { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
];
export const defaultData = {
  name: "Mexico Exports",
  customShipmentGrid: true,
  showUiUeLevelTwo: true,
  isProductChemicalPresent: true,
  isViewShipmentURLModified: true,
  date: "formatted_payment_date",
  analyticsDefault: analyticDropdownOptions[0].value,
  analyticsRangeDownloadPresent: true,
  isShipmentGridNew: true,
  isViewAllGridNew: true,
  showUiTrends: true,
  isUIGridNew: true,
  isUEGridNew: true,
  isFilterGroupingPresent: true,
  exportPDFInAnalytics: false,
  exportPDFInAnalyticsFrontend: true,
  minimumDateAllowed: "2011-01-01",
  isImpExpGraph: true,
  trendsTableCompanyID: {
    shipper: "hashed_id",
    consignee: "hashed_id",
  },
  importer_exporter_graph_sort__options: [
    { value: "doc_count", value1: "date", label: "Shipments", table_header: "Total Shipments" },
    { value: "shipment_value", label: "Value (USD)", table_header: "Total Shipment Value(USD)" },
    { label: "Weight (kg)", value: "weight", value1: "weight", table_header: "TotalWeight (kg)" },
  ],
  apiEndPoints: {
    getArrivalDate: getApiUrl("mexicoExportLatestArrivalDate"),
    getSearchResult: getApiUrl("mexicoExportSearch"),
    getAnalyticsData: getApiUrl("analytics/mexicoExportAnalytics"),
    saveProspectiveExportersApi: "addFavouriteCompany",
    saveProspectiveImportersApi: "addFavouriteCompany",
    downloadShipmentsApi: getApiUrl("create_excel_mexico_exports"),
    downloadUniqueImporterExporter: getApiUrl("create_excel_mexico_exports"),
    getShipmentByID: getApiUrl("mexicoExportShipmentByID"),
    getShipmentDownloadData: getApiUrl("renderToPdfMexicoExports"),
    renderToPdfAnalytics: getApiUrl("renderToPdfAnalytics"),
    getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
    getCompanySlug: getApiUrl("companyProfiles/getSlug"),
    getSavedSearchPayloadById: getApiUrl("getSavedSearchPayloadById"),
    getMasterListsForAutoSearchFeilds: getApiUrl("dashboard/getMasterListsForAutoSearchFeilds"),
    getAnalyticsViewAll: getApiUrl("analytics/mexicoExportAnalyticsViewAll"),
    getMissingTabData: getApiUrl("intelSearchWhatAreMissing"),
    getImpExpGraphData: getApiUrl("intelSearchMexicoExportGraph"),
  },
  isAdvancedSearchAvailable: false,
  country_small: globalCountryDetails.mx_export.country_small,
  countryCaps: globalCountryDetails.mx_export.country_caps,
  product_id: globalCountryDetails.mx_export.product_id,
  compare_product_id: globalCountryDetails.mx_export.compareProduct,
  country_CamelCase: globalCountryDetails.mx_export.product_id,
  countryCode: globalCountryDetails.mx_export.countryCode,
  countryType: globalCountryDetails.mx_export.countryType,
  manyCountryType: globalCountryDetails.mx_export.manyCountryType,
  countryTypeCode: globalCountryDetails.mx_export.countryTypeCode,
  redirectionID: globalCountryDetails.mx_export.redirectionID,
  analyticsCountryID: globalCountryDetails.mx_export.analyticsCountryID,
  autoSuggestLanguage: autosuggestLanguageOptions.english,
  dateRangeHeading: "Shipment Date Range",
  monthRangeHeading: "Month of Export",
  onboardingText: {
    reacttourDateRange: "Customize your shipment basis payment date",
    reacttourFilterH: "Filters Button",
    reacttourFilterP: "Use filters to get most relevant shipments for you",
    reacttourMainSearchH: "Start searching for Mexico Exports Shipments",
    reacttourMainSearchP: "HS Codes and Consignees",
    navTabP: "View unique importers in the search result and add them to your prospect list.",
    savedSearchButtonP: "Reload from Saved Searches, for quick shipments data access.",
  },
  picker: {
    monthPicker: false,
    datePicker: true,
  },
  tabKeyWords: {
    shipments: true,
    analytics: true,
    exporters: true,
    importers: true,
    whatYouAreMissing: true,
    reports: true,
  },
  main_dropdown_options: {
    entire_bill_of_lading: false,
    product_description: true,
    product_hscode: true,
    exporters: true,
    importers: true,
    allCategory: true,
    ports: true,
    chemical_description: true,
  },
  searchCategoryList: globalCountryDetails.mx_export.defaultDropDown,
  specialFields: {
    hscode: "hsCode",
    consignee: "derivedConsigneeMasterName",
    shipper: "derivedShipperMasterName",
    weight: "weight",
    teu: "teu",
    value: "shipmentValue",
    productCategory: "productCategory",
    sixDigitHsCode: "sixDigitHsCode",
    portOfLading: "standardLadingPortName",
    // portOfUnlading: "standardUnladingPortName",
  },
  filterObj: {
    countryOfDestinationRegion: "countryOfDestinationRegion",
    countryOfExportRegion: "countryOfExportRegion",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountryRegion",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountryRegion",
    shipper: "shipper",
    shipperCity: "shipperCity",
    shipperStateRegion: "shipperStateRegion",
    shipperZipcode: "shipperZipcode",
    consignee: "consignee",
    standardLadingPortName: "standardLadingPortName",
    customHouseNameCode: "customHouseNameCode",
    customsHouseState: "customsHouseState",
    customsRegime: "customsRegime",
    ModeOfTransport: "ModeOfTransport",
    shipmentValue: "shipmentValue",
    hsCode: "hsCode",
    derivedShipperMasterName: "derivedShipperMasterName",
    derivedConsigneeMasterName: "derivedConsigneeMasterName",
    isExporter: "isExporter",
    isImporter: "isImporter",
    sixDigitHsCode: "sixDigitHsCode",
    productCategory: "productCategory",
    industryCategory: "industryCategory",
    weight: "weight",
    quantityUnit: "quantityUnit",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
    incoterm: "incoterm",
  },
  booleanFilterObj: {
    exclude_blank_consignee: "exclude_blank_consignee",
    exclude_blank_shipper: "exclude_blank_shipper",
  },
  boxRangeFilterList: {
    shipmentValue: "shipmentValue",
    weight: "weight",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
  },
  boxFilterObj: {
    shipmentValue: [],
    weight: [],
    perUnitValue: [],
    quantityRange: [],
  },
  localisationFilterObj: {
    countryOfDestinationRegion: "countryOfDestination",
    countryOfExportRegion: "countryOfExport",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountry",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountry",
    shipperStateRegion: "shipperState",
  },
  emptyFilterObj: {
    countryOfDestinationRegion: [],
    countryOfExportRegion: [],
    consigneeJurisdictionCountryRegion: [],
    shipperJurisdictionCountryRegion: [],
    shipper: [],
    shipperCity: [],
    shipperStateRegion: [],
    shipperZipcode: [],
    consignee: [],
    standardLadingPortName: [],
    customHouseNameCode: [],
    customsHouseState: [],
    customsRegime: [],
    ModeOfTransport: [],
    shipmentValue: [],
    hsCode: [],
    sections: [],
    derivedShipperMasterName: [],
    derivedConsigneeMasterName: [],
    isImporter: [],
    isExporter: [],
    sixDigitHsCode: [],
    productCategory: [],
    industryCategory: [],
    weight: [],
    quantityUnit: [],
    perUnitValue: [],
    quantityRange: [],
    incoterm: [],
  },
  defaultBooleanFilterObj: {
    exclude_blank_consignee: false,
    exclude_blank_shipper: false,
  },
  selectAll: {
    countryOfDestinationRegion: false,
    countryOfExportRegion: false,
    consigneeJurisdictionCountryRegion: false,
    shipperJurisdictionCountryRegion: false,
    shipper: false,
    shipperCity: false,
    shipperStateRegion: false,
    shipperZipcode: false,
    consignee: false,
    standardLadingPortName: false,
    customHouseNameCode: false,
    customsHouseState: false,
    customsRegime: false,
    ModeOfTransport: false,
    shipmentValue: false,
    hsCode: false,
    sections: false,
    derivedShipperMasterName: false,
    derivedConsigneeMasterName: false,
    isImporter: false,
    isExporter: false,
    sixDigitHsCode: false,
    productCategory: false,
    industryCategory: false,
    weight: false,
    quantityUnit: false,
    perUnitValue: false,
    quantityRange: false,
    incoterm: false,
  },
  specialMappingFields: {
    derived_hs_codes_string: {
      derived_hs_codes_string: {
        key: "derived_hs_codes_string",
        value: "",
      },
      derived_hs_codes_string_estimated: {
        key: "derived_hs_codes_string_estimated",
        value: "",
      },
      derived_hs_codes_string_estimated_is_present: {
        key: "derived_hs_codes_string_estimated_is_present",
        value: "Estimated HSCode",
      },
      fallback: "Not Available",
    },
    derived_shipment_value: {
      derived_shipment_value: {
        key: "derived_shipment_value",
        value: "",
      },
      derived_shipment_value_is_present: {
        key: "derived_shipment_value_is_present",
        value: "",
      },
      fallback: "Not Available",
    },
    shipper_party_name: {
      shipper_party_name: {
        key: "shipper_party_name",
        value: "",
      },
      fallback: "Not Declared",
    },
  },
  normalfilterList: [
    { categoryName: "shipperDetails", heading: "Filter by Shipper Standardized Name", eventKey: "32", key: "derivedShipperMasterName", type: filterType.normalFilter, label: "Shipper Standardized Name", viewAllPlaceHolder: "Search in Shipper Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { categoryName: "consigneeDetails", heading: "Filter by Consignee Standardized Name", eventKey: "31", key: "derivedConsigneeMasterName", type: filterType.normalFilter, label: "Consignee Standardized Name", viewAllPlaceHolder: "Search in Consignee Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { categoryName: "shipperDetails", heading: "Filter by Shipper Name", eventKey: "2", key: "shipper", type: filterType.normalFilter, mapFiltersType: "normal", label: "Shipper Name", viewAllPlaceHolder: "Search in Shipper Name Filter", emptyFilterText: "No matching filters found for this search", searchInFilterKey: "" },
    { categoryName: "consigneeDetails", heading: "Filter by Consignee Name", eventKey: "6", key: "consignee", type: filterType.normalFilter, mapFiltersType: "normal", label: "Consignee Name", viewAllPlaceHolder: "Search in Consignee Name Filter", emptyFilterText: "No matching filters found for this search", searchInFilterKey: "" },
    { categoryName: "consigneeDetails", heading: "Filter by Country of Import ", eventKey: "1", key: "countryOfDestinationRegion", altKey: "countryOfDestination", type: filterType.localizeFilter, mapFiltersType: "normal", label: "Country of Import", viewAllPlaceHolder: "Search in Country of Import Filter", emptyFilterText: "No matching filters found for this search", searchInFilterKey: "" },
    { categoryName: "shipperDetails", heading: "Filter by Country of Export ", eventKey: "1", key: "countryOfExportRegion", altKey: "countryOfExport", type: filterType.localizeFilter, mapFiltersType: "normal", label: "Country of Export", viewAllPlaceHolder: "Search in Country of Export Filter", emptyFilterText: "No matching filters found for this search", searchInFilterKey: "" },
    { categoryName: "consigneeDetails", heading: "Filter by Consignee Jurisdiction Country", eventKey: "25", key: "consigneeJurisdictionCountryRegion", altKey: "consigneeJurisdictionCountry", type: filterType.localizeFilter, label: "Consignee Jurisdiction Country", viewAllPlaceHolder: "Search Consignee Jurisdiction Country", emptyFilterText: "", searchFilterString: "" },
    { categoryName: "shipperDetails", heading: "Filter by Shipper Jurisdiction Country", eventKey: "25", key: "shipperJurisdictionCountryRegion", altKey: "shipperJurisdictionCountry", type: filterType.localizeFilter, label: "Shipper Jurisdiction Country", viewAllPlaceHolder: "Search Shipper Jurisdiction Country", emptyFilterText: "", searchFilterString: "" },
    { categoryName: "shipperDetails", heading: "Filter by Shipper State ", eventKey: "3", key: "shipperStateRegion", altKey: "shipperState", type: filterType.localizeFilter, mapFiltersType: "normal", label: "Shipper State", viewAllPlaceHolder: "Search in Shipper State Filter", emptyFilterText: "No matching filters found for this search", searchInFilterKey: "" },
    { categoryName: "shipperDetails", heading: "Filter by Shipper City ", eventKey: "4", key: "shipperCity", type: filterType.normalFilter, mapFiltersType: "normal", label: "Shipper City", viewAllPlaceHolder: "Search in Shipper City Filter", emptyFilterText: "No matching filters found for this search", searchInFilterKey: "" },
    { categoryName: "shipperDetails", heading: "Filter by Shipper ZipCode ", eventKey: "5", key: "shipperZipcode", type: filterType.normalFilter, mapFiltersType: "normal", label: "Shipper ZipCode", viewAllPlaceHolder: "Search in Shipper ZipCode Filter", emptyFilterText: "No matching filters found for this search", searchInFilterKey: "" },
    { categoryName: "ports", heading: "Filter by Port of Lading ", eventKey: "9", key: "standardLadingPortName", type: filterType.normalFilter, mapFiltersType: "normal", label: "Port of Lading", viewAllPlaceHolder: "Search in Port of Lading Filter", emptyFilterText: "No matching filters found for this search", searchInFilterKey: "" },
    { categoryName: "ports", heading: "Filter by Customs House", eventKey: "18", key: "customHouseNameCode", type: filterType.normalFilter, label: "Customs House", viewAllPlaceHolder: "Search in Customs House Filter", emptyFilterText: "", searchFilterString: "" },
    { categoryName: "ports", heading: "Filter by Customs House State ", eventKey: "10", key: "customsHouseState", type: filterType.normalFilter, mapFiltersType: "normal", label: "Customs House State", viewAllPlaceHolder: "Search in Customs House State Filter", emptyFilterText: "No matching filters found for this search", searchInFilterKey: "" },
    { categoryName: "ports", heading: "Filter by Customs Regime ", eventKey: "11", key: "customsRegime", type: filterType.normalFilter, mapFiltersType: "normal", label: "Customs Regime", viewAllPlaceHolder: "Search in Customs Regime Filter", emptyFilterText: "No matching filters found for this search", searchInFilterKey: "" },
    { categoryName: "freightType", heading: "Filter by Mode of Transportation ", eventKey: "12", key: "ModeOfTransport", type: filterType.normalFilter, mapFiltersType: "normal", label: "Mode of Transportation", viewAllPlaceHolder: "Search in Mode of Transportation ", emptyFilterText: "No matching filters found for this search", searchInFilterKey: "" },
    { categoryName: "cargoDetails", heading: "Filter by Product Category ", eventKey: "14", key: "productCategory", type: filterType.normalFilter, mapFiltersType: "normal", label: "Product Category", viewAllPlaceHolder: "Search in Product Category Filter", emptyFilterText: "", searchInFilterKey: "" },
    { categoryName: "cargoDetails", heading: "Filter by Industry Group ", eventKey: "33", key: "industryCategory", type: filterType.normalFilter, mapFiltersType: "normal", label: "Industry Group", viewAllPlaceHolder: "Search in Industry Group Filter", emptyFilterText: "", searchInFilterKey: "" },
    { categoryName: "cargoDetails", heading: "Filter by HS Code ", eventKey: "14", key: "hsCode", type: filterType.hsCodeFilter, mapFiltersType: "hs-code", label: "HS Code", viewAllPlaceHolder: "Search in HS Code Filter", emptyFilterText: "No matching filters found for this search", searchInFilterKey: "" },
    { categoryName: "cargoDetails", heading: "Filter by Shipment Value ", eventKey: "15", key: "shipmentValue", type: filterType.boxFilter, mapFiltersType: "weight", label: "Shipment Value", viewAllPlaceHolder: "Search in Shipment Value Filter", emptyFilterText: "No matching filters found for this search", searchInFilterKey: "" },
    { categoryName: "cargoDetails", heading: "Filter by Weight", eventKey: "20", key: "weight", type: filterType.boxFilter, label: "Weight", viewAllPlaceHolder: "", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: false },
    { categoryName: "shipperDetails", heading: "Filter by Shipper Type", eventKey: "2", key: "isExporter", type: filterType.normalFilter, label: "Shipper Type", viewAllPlaceHolder: "Search in Shipper Type Filter", emptyFilterText: "", searchFilterString: "", isTitleCase: true },
    { categoryName: "consigneeDetails", heading: "Filter by Consignee Type", eventKey: "6", key: "isImporter", type: filterType.normalFilter, label: "Consignee Type", viewAllPlaceHolder: "Search in Consignee Type Filter", emptyFilterText: "", searchFilterString: "", isTitleCase: true },
    { categoryName: "cargoDetails", heading: "Filter by 6 digit HS Code", eventKey: "9", key: "sixDigitHsCode", type: filterType.normalFilter, label: "6 Digit HS Code", viewAllPlaceHolder: "Type to Search 6 digit HS Code", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Quantity Unit", categoryName: "cargoDetails", eventKey: "32", key: "quantityUnit", additionalKey: "quantityRange", type: filterType.normalFilter, label: "Quantity", viewAllPlaceHolder: "Search Quantity Unit", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: true, isParanthesesCapital: false, additionalType: "multiSelectRangeFilter" },
    { heading: "Filter by Per Unit Value (USD)", categoryName: categoryType.cargoDetails, eventKey: "32", key: "perUnitValue", type: filterType.multiSelectRangeFilter, label: "Per Unit Value (USD)", viewAllPlaceHolder: "", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: false, isParanthesesCapital: false },
    { heading: "Filter by Incoterm", categoryName: categoryType.freightType, eventKey: "22", key: "incoterm", type: filterType.normalFilter, label: "Incoterm", viewAllPlaceHolder: "Search in Incoterm Filter", emptyFilterText: "", searchFilterString: "", isNoTransform: true },
  ],
  internalFilterList: [
    { isVisible: true, key: "uniqueImportExporterShipment" },
    { isVisible: false, key: "uniqueImportExporterWeight" },
    { isVisible: false, key: "uniqueImportExporterTeu" },
    { isVisible: true, key: "uniqueImportExporterValue" },
  ],
  highLightedColumnList: [
    { key: "pedimento_number_str", label: "Pedimento Number" },
    { key: "derived_hs_code", label: "HS Code" },
    { key: "mexican_trading_entity_business_name", label: "Shipper Name" },
    { key: "derived_shipper_mastername", label: "Shipper Name" },
    { key: "mexican_trading_entity_tax_identification_number", label: "Shipper Tax Identification Number" },
    { key: "mexican_trading_entity_address", label: "Shipper Address" },
    { key: "foreign_trading_entity_name", label: "Consignee Name" },
    { key: "derived_consignee_mastername", label: "Consignee Name" },
    { key: "derived_shipper_parent_company_name", label: "Shipper Parent Company" },
    { key: "derived_consignee_parent_company_name", label: "Consignee Parent Company" },
    { key: "foreign_trading_entity_registration_number", label: "Consignee Tax Identification Number" },
    { key: "foreign_trading_entity_address", label: "Consignee Address" },
    { key: "customs_broker_code", label: "Customs Broker Code" },
    { key: "customs_broker_code_str", label: "Customs Broker Code" },
    { key: "product_description_spanish", label: "Product Description (Spanish)" },
    { key: "product_description_translated", label: "Product Description" },
    { key: "product_description_english_ml", label: "Product Description" },
    { key: "derived_shipper_master_name", label: "Shipper Standardized Name" },
    { key: "derived_consignee_master_name", label: "Consignee Standardized Name" },
    { key: "derived_customs_house_name", label: "Customs House" },
    { key: "derived_product_description_english", label: "Product Description" },
  ],
  shipmentSorting: [
    { columnKey: "formatted_payment_date", value: "date", isDefault: true },
    { columnKey: "commercial_invoice_value_usd", value: "shipment_value", isDefault: false },
  ],
  exporterSorting: [
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: true },
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: false },
    { name: "Weight (kg)", columnKey: "weight", value: "weight", isDefault: false },
  ],
  importerSorting: [
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: true },
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: false },
    { name: "Weight (kg)", columnKey: "weight", value: "weight", isDefault: false },
  ],
  sortKeyMap: {
    date: "formatted_payment_date",
    shipment_value: "commercial_invoice_value_usd",
  },
  sortKeyUniqueImpExpMap: {
    date: "doc_count",
    shipment_value: "shipment_value",
  },
  analyticsHeaderItems: [
    { label: "Total Shipments Exported", key: "total_shipments", valuePrefix: "", valueSuffix: "" },
    { label: "Total Shipments Value", key: "total_value", valuePrefix: "USD", valueSuffix: "" },
    { label: "Total Shipments Weight", key: "total_weight", valueSuffix: "Kg", valuePrefix: "" },
  ],
  analyticsFieldsMapping: [
    { key: "trade_country_of_export_to_import", filterKey1: "countryOfExportRegion", filterKey2: "countryOfDestinationRegion", label: "Trade Routes (Country of Export → Country of Import)", headerOne: "Country of Export", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    { key: "trends", filterKey: "", label: "Export Trends", type: analyticsType.trends, showTrends: true, showlevelTwo: false },
    { key: "derived_origin_destination_country_english", filterKey: "countryOfDestinationRegion", label: "Countries of Import", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "customs_house_name" },
    { key: "mexican_trading_entity_state", filterKey: "shipperStateRegion", label: "Shipper States", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_origin_destination_country_english" },
    { key: "customs_house_name", filterKey: "standardLadingPortName", label: "Ports of Lading", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_origin_destination_country_english", profileType: redirectingProfileEnum.portOfLading.key },
    // { key: "trade_country", filterKey1: "shipperStateRegion", filterKey2: "countryOfDestinationRegion", label: "Trade Routes (Mexico State of Shipper → Country of Import)", headerOne: "Shipper State", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    // { key: "trade_port", filterKey1: "standardLadingPortName", filterKey2: "countryOfDestinationRegion", label: "Trade Routes (Port of Lading → Country of Import)", headerOne: "Customs House", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    { key: "derived_mode_of_transport_english", filterKey: "ModeOfTransport", label: "Mode of Transportation", type: analyticsType.pieChart, showTrends: true, showlevelTwo: true, defaultKey: "derived_origin_destination_country_english" },
    { key: "hs_code", headerLabel: "HS Code", filterKey: "hsCode", label: "2-digit HS Codes", type: analyticsType.hsCode, infoText: "Analytics data is based on the summary of the shipments obtained through a search query.<br/> Hence the data may contain aggregated results for all products, HS Codes present in the search results.", showTrends: false, showlevelTwo: false },
    { key: "six_digit_hs_code", headerLabel: "6 digit HS Code", filterKey: "sixDigitHsCode", label: "6 digit HS Codes", type: analyticsType.hsCode, showTrends: true, showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    { key: "customs_house_name_code", filterKey: "customHouseNameCode", label: "Customs Houses", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_origin_destination_country_english" },
  ],
  searchTableColumns: [
    { key: "", name: "View", selector: "", dataTip: "", type: "viewShipment", button: true, staticField: true, grow: 0, miWidth: "40px", maWidth: "40px" },
    { key: "s_no", name: "S No", selector: "s_no", dataTip: "", type: "", maxWidth: "84px !important", minWidth: "84px !important", grow: 0, wrap: true, staticField: true, miWidth: "60px", maWidth: "60px" },
    { key: "formatted_payment_date", name: "Tax Payment Date", selector: "formatted_payment_date", dataTip: "", type: "", dateFormat: "MMM DD, YYYY", sortable: true, grow: 1, wrap: true, miWidth: "140px", maWidth: "140px" },
    { key: "matched_column", name: "Matching Fields", selector: "matched_column", dataTip: "", type: "matchingField", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "derived_hs_code", name: "HS Code", selector: "derived_hs_code", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "100px", maWidth: "100px" },
    { key: "product_description_spanish", name: "Product", selector: "product_description_spanish", tooltipValue: "product_description_spanish", type: "", grow: 2, wrap: true, isSliceEnabled: true, sliceLength: 40, miWidth: "120px", maWidth: "120px" },
    { key: "quantity", name: "Quantity", selector: "quantity", secondarySelector: "derived_quantity_unit_english", dataTip: "", type: "", grow: 0, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "100px", maWidth: "100px" },
    // { name: 'Net Weight (kg)', selector: 'net_weight', dataTip: '', type: '', sortable: true, grow: 1, wrap: true, miWidth:"60px",maWidth:"60px"},
    { key: "derived_consignee_master_name", name: "Consignee Name", selector: "derived_consignee_master_name", alternateSelector: "foreign_trading_entity_name", id: "derived_consignee_master_company_id", dataTip: "", type: "companyRedirect", companyType: "I", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "derived_shipper_master_name", name: "Shipper Name", selector: "derived_shipper_master_name", alternateSelector: "mexican_trading_entity_business_name", id: "derived_shipper_master_company_id", dataTip: "", type: "companyRedirect", companyType: "E", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "derived_origin_destination_country_english", name: "Country Of Import", selector: "derived_origin_destination_country_english", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "commercial_invoice_value_usd", name: "Shipment Value (USD)", selector: "commercial_invoice_value_usd", dataTip: "", type: "", sortable: true, grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "140px", maWidth: "140px" },
  ],
  exporterTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true, capitalize: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true },
    { key: "weight", name: "Weight(kg)", selector: "weight", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "shipment_value", name: "Shipment Value (USD)", sortable: true, selector: "shipment_value", dataTip: "", type: "", isCommaFormat: true, fixedValueUpto: 2, grow: 1, wrap: true },
    { key: "oldest_shipment_date", name: "First Exported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Exported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  importerTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true, capitalize: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true },
    { key: "weight", name: "Weight(kg)", selector: "weight", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "shipment_value", name: "Shipment Value (USD)", selector: "shipment_value", sortable: true, dataTip: "", type: "", isCommaFormat: true, fixedValueUpto: 2 },
    { key: "oldest_shipment_date", name: "First Imported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Imported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    // { key: "country", showUiUeTwoLevel: false, name: "Country", selector: "country", dataTip: "", type: "", isFirstLetterCapital: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  viewShipmentDetails: [
    {
      id: 1,
      title: "",
      growValue: 12,
      isHeader: true,
      imgUrl: "",
      data: [
        { label: "Tax Payment Date", value: "formatted_payment_date", dateFormat: true, monthFormat: false },
        { label: "Entry Date", value: "formatted_entry_date", dateFormat: true, preValidate: true, monthFormat: false },
        { label: "Pedimento Number", value: "pedimento_number_str" },
        { label: "Mode of Transportation", value: "derived_mode_of_transport_english" },
        { label: "Incoterm", value: "incoterm_description", tooltip: true, tooltipField: "incoterm", preValidate: true },
        { label: "HS Code", value: "derived_hs_code" },
      ],
    },
    {
      id: 2,
      title: "Shipment Origin Details",
      isConnectedColumn: true,
      isCompactHeader: true,
      growValue: 6,
      isHeader: false,
      imgUrl: "",
      data: [
        { label: "Port of Lading", value: "derived_customs_house_name", tooltip: false, tooltipField: "customs_house_code", tooltipPrefix: "Custom House Code: ", tooltipValue: "", type: "redirect", redirectionID: "derived_port_of_lading_master_id", profileType: redirectingProfileEnum.portOfLading.key },
        { label: "Shipper Standardized Name", value: "mexican_trading_entity_business_name", type: "redirect", companyIdKey: "derived_shipper_master_company_id", companyKey: "", derivedCompanyKey: "derived_shipper_master_name", tradeDirection: "E" },
        { label: "Shipper Jurisdiction Country ", value: "derived_shipper_jurisdiction_country", countryFlag: true, countryCodeField: "derived_shipper_jurisdiction_country_code" },
        { label: "Shipper Name", value: "mexican_trading_entity_business_name", capitalize: "true" },
        { label: "Shipper Type", value: "derived_is_exporter", tooltip: false, tooltipField: "" },
        { label: "Tax Identification Number", value: "mexican_trading_entity_tax_identification_number", preValidate: true },
        { label: "Country of Export", value: "derived_country_of_export", countryFlag: true, countryCodeField: "derived_country_of_export_code", capitalize: "true", preValidate: true },
        { label: "Shipper State", value: "mexican_trading_entity_state", capitalize: "true", preValidate: true },
        { label: "Shipper City", value: "derived_mexican_trading_entity_municipality", capitalize: "true", preValidate: true },
        { label: "Shipper Zipcode", value: "derived_mexican_trading_entity_postal_code", capitalize: "true", preValidate: true },
        { label: "Shipper Address", value: "mexican_trading_entity_address", capitalize: "true", preValidate: true, isReadMore: true, readMoreLength: 45 },
      ],
    },
    {
      id: 3,
      title: "Shipment Destination Details",
      growValue: 6,
      isHeader: false,
      isCompactHeader: true,
      imgUrl: "",
      data: [
        { label: "Country of Import", value: "derived_country_of_import", countryFlag: true, countryCodeField: "derived_country_of_import_code", capitalize: "true", preValidate: true },
        { label: "Consignee Standardized Name", value: "foreign_trading_entity_name", type: "redirect", companyIdKey: "derived_consignee_master_company_id", companyKey: "", derivedCompanyKey: "derived_consignee_master_name", tradeDirection: "I" },
        { label: "Consignee Jurisdiction Country ", value: "derived_consignee_jurisdiction_country", countryFlag: true, countryCodeField: "derived_consignee_jurisdiction_country_code" },
        { label: "Consignee Name", value: "foreign_trading_entity_name", capitalize: "true" },
        { label: "Consignee Type", value: "derived_is_importer" },
        { label: "Consignee Registration Number", value: "foreign_trading_entity_registration_number", preValidate: true },
        // { label: "Country of Import", value: "derived_foreign_trading_entity_country_english", capitalize: "true", preValidate: true },
        { label: "Consignee State", value: "foreign_trading_entity_state", capitalize: "true", preValidate: true },
        { label: "Consignee Zipcode", value: "foreign_trading_entity_zipcode", capitalize: "true", preValidate: true },
        { label: "Consignee Address", value: "foreign_trading_entity_address", capitalize: "true", preValidate: true, isReadMore: true, readMoreLength: 45 },
      ],
    },
    {
      id: 4,
      title: "Customs Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
      data: [
        { label: "Customs House", value: "derived_customs_house_name_code" },
        { label: "Customs House State", value: "derived_customs_house_state" },
        { label: "Customs Regime", value: "derived_customs_classification_english", tooltip: true, tooltipField: "customs_classification_code", tooltipValue: "" },
        { label: "Customs Broker Code", value: "customs_broker_code" },
      ],
    },
    {
      id: 5,
      title: "Cargo Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [
        { label: "HS Code", value: "derived_hs_code" },
        { label: "Sequence Number", value: "secuencia", preValidate: true },
        { label: "Product Description", value: "derived_product_description_english", isReadMore: true, readMoreLength: 45 },
        { label: "Product Description (Spanish)", value: "product_description_spanish", isReadMore: true, readMoreLength: 45 },
        { label: "Quantity", value: "quantity", unitField: "derived_quantity_unit_english", dynamicUnit: true, valueSuffix: "", preValidate: true, isCommaFormat: true },
        { label: "Commercial Invoice  Value", value: "commercial_invoice_value_usd", valuePrefix: "USD ", tooltip: true, tooltipField: "commercial_invoice_value_peso", tooltipPrefix: "PESO ", tooltipValue: "", preValidate: true, isCommaFormat: true },
        { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
        { label: "Insurance", value: "SEGUROS", valuePrefix: "USD ", preValidate: true },
        { label: "Freight", value: "IMP_FLETE", valuePrefix: "USD ", preValidate: true },
        { label: "Value (USD)", value: "value_usd", valuePrefix: "USD ", tooltip: true, tooltipField: "value_peso", tooltipPrefix: "PESO ", tooltipValue: "", preValidate: true, isCommaFormat: true },
        { label: "Weight", value: "derived_weight_kg", valueSuffix: " kg", isCommaFormat: true },
        { label: "Pedimento Gross Weight", value: "gross_weight_kg", valueSuffix: " kg", isCommaFormat: true },
      ],
    },
  ],
  onboardingSteps: [
    { selector: "#reacttourdaterange", disableInteraction: true, header: "", description: "Customize your search basis shipment departure date", float: "", position: "left" },
    { selector: "#reacttourFilter", disableInteraction: true, header: "Filters Button", description: "Use filters to get most relevant shipments for you", float: "right", position: "right" },
    { selector: "#reacttourMainSearch", disableInteraction: true, header: "Start searching for Mexico Exports Shipments", description: "Entire Bill of Lading, HS Codes, Product Description, and Suppliers", float: "right", position: "bottom" },
    { selector: "#nav-tab", disableInteraction: true, header: "", description: "View unique shippers in the search result and add them to your prospect list.", float: "right", position: "bottom" },
    { selector: ".saved-search-button", disableInteraction: true, header: "", description: "Reload from Saved Searches, for quick shipments data access.", float: "", position: "bottom" },
  ],
  defaultUeUiSecondLevelKey: "derived_origin_destination_country_english",
  twoColumnMapping: {
    trade_country_of_export_to_import: "Trade Routes (Country of Export → Country of Import)",
    mexican_trading_entity_state: "Shipper States",
    derived_mode_of_transport_english: "Mode of Transportation",
    // trade_port: "Trade Routes (Mexico State of Shipper → Country of Import)",
    trade_country: "Trade Routes (Customs House → Country of Import)",

    derived_consignee_master_name: "Unique Importers",
    derived_shipper_master_name: "Unique Exporters",
    derived_origin_destination_country_english: "Countries of Import",
    customs_house_name: "Port of Lading",
    six_digit_hs_code: "6 digit HS Codes",
  },
};

const MexicoExportSearch = () => {
  return <Shipments defaultData={defaultData} analyticDropdownOptions={analyticDropdownOptions} trendsDropdownOptions={trendsDropdownOptions} />;
};
export default MexicoExportSearch;
